import { render, staticRenderFns } from "./TogglePreviewButton.vue?vue&type=template&id=8042ace4&scoped=true"
import script from "./TogglePreviewButton.vue?vue&type=script&lang=js"
export * from "./TogglePreviewButton.vue?vue&type=script&lang=js"
import style0 from "./TogglePreviewButton.vue?vue&type=style&index=0&id=8042ace4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8042ace4",
  null
  
)

export default component.exports